import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodepenCircleFilledSvg from "@ant-design/icons-svg/es/asn/CodepenCircleFilled";
import AntdIcon from '../components/AntdIcon';
var CodepenCircleFilled = function CodepenCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: CodepenCircleFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(CodepenCircleFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CodepenCircleFilled';
}
export default RefIcon;